import type { TSoilIrrigationActivityScope } from 'stores/detailsPanelStore/detailsPanelStore'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'

export const getIrrigationActivityScope = ({
  chosenScope,
  soilPoint,
}: {
  chosenScope: TSoilIrrigationActivityScope | null
  soilPoint: TPoint | null | undefined
}): TSoilIrrigationActivityScope => {
  // the URL and saved state can hold any value, so only a real choice counts
  if (chosenScope === 'PROBE' || chosenScope === 'ZONE') return chosenScope

  const pressureTransducerEmitterTypes = soilPoint?.configuration.irrigationEmitterTypesAvailable ?? []

  return pressureTransducerEmitterTypes.length > 0 ? 'PROBE' : 'ZONE'
}
